.block {
  width: 180px;
  height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color: #ffffff;
  margin: 5px;
  border-radius: 20px;
  box-shadow: 3px 3px 5px rgba(99, 99, 99, 0.066);

  cursor: pointer;

  .img {
    position: absolute;
    background-color: #ffffff;
    &:hover {
      transform: scale(1.07);
      opacity: 1;
    }
    transition: transform 200ms;
  }

  .creator {
    position: relative;
    top: 80px;
    right: -20px;
    font-size: 0.75rem;
    font-weight: 520;
    color: rgb(243, 243, 243);
    background-color: #194475;
    height: 20px;
    width: 130px;
    text-align: center;
    line-height: 20px;
    border-radius: 5px;
  }
}
